const Authorization = {
  dashboard: ['*'],

  tokenprofiles: {
    view: ['Show Token Profiles', 'Create Token Profiles', 'Delete Token Profiles'],
    create: ['Create Token Profiles'],
    delete: ['Delete Token Profiles'],
  },
  keystore: {
    keys: {
      view: ['Show Keys', 'Create and Edit Keys', 'Delete Key'],
      edit: ['Create and Edit Keys'],
      delete: ['Delete Key'],
    },
    keyRotation: ['Key Rotation Settings'],
    trustedTLSIssuer: ['Select TLS Key'],
  },
  services: {
    proxies: {
      view: ['Show Proxies', 'Create and Edit Proxy', 'Delete Proxy'],
      edit: ['Create and Edit Proxy'],
      delete: ['Delete Proxy'],
      runtime: ['Show Services', 'Change Service Status'],
    },
    webServices: ['*'],
    mssql: {
      view: ['View Adapter-MSSQL Settings', 'Modify Adapter-MSSQL Settings', 'View Adapter-MSSQL Users', 'Modify Adapter-MSSQL Users'],
      edit: ['Modify Adapter-MSSQL Settings'],
      viewUser: ['View Adapter-MSSQL Users', 'Modify Adapter-MSSQL Users'],
      editUser: ['Modify Adapter-MSSQL Users'],
    },
  },
  apps: {
    view: ['Show Apps', 'Create and Edit App'],
    edit: ['Create and Edit App'],
  },
  info: {
    version: ['*'],
    database: ['Show database configuration'],
    LogFile: ['Show LogFile'],
  },
  bgSchedule: {
    view: ['Show Background Tasks', 'Create and Edit Background Tasks'],
    edit: ['Create and Edit Background Tasks'],
  },
  settings: {
    changeRequest: ['*'],
    tokenDatabase: {
      view: ['Show database configuration', 'Edit database configuration'],
      edit: ['Edit database configuration'],
    },
    advancedSettings: {
      view: ['View Advanced Configuration', 'Modify Advanced Configuration'],
      edit: ['Modify Advanced Configuration'],
    },
    license: {
      view: ['Show License', 'Modify License'],
      edit: ['Modify License'],
    },
    masterKey: ['Create and Edit Master Password policy'],
    rootCertificate: {
      view: ['View Root Certificate', 'Download Root Certificate'],
    },
    solrConfig: {
      view: ['Show Solr Schema', 'Modify Solr Schema'],
      edit: ['Modify Solr Schema'],
    },
    ssoProxy: {
      view: ['Show SSO Proxy', 'Modify SSO Proxy'],
      edit: ['Modify SSO Proxy'],
    },
    syslogIntegration: {
      view: ['Show Syslog Configuration', 'Create and Edit Syslog Configurations'],
      edit: ['Create and Edit Syslog Configurations'],
    },
    o365Setting: {
      view: ['Show Office 365 Configuration', 'Edit Office 365 Configuration'],
      edit: ['Edit Office 365 Configuration'],
    },
  },
  userManagement: {
    administration: {
      viewAdmin: ['Show Administrators', 'Create and Edit Administrator'],
      editAdmin: ['Create and Edit Administrator'],
      viewRole: ['Show Roles', 'Create and Edit Role'],
      editRole: ['Create and Edit Role'],
      assignRole: ['Assign Roles'],
    },
    passwordPolicy: {
      view: ['*'],
      edit: ['Create and Edit Password policy'],
    },
    adMapping: ['Assign Roles'],
    policyUsers: ['*'],
    activeDirectory: {
      view: ['Show Active Directory Configuration', 'Edit Active Directory Configuration'],
      edit: ['Edit Active Directory Configuration'],
    },
  },
  adapter: {
    view: ['View Policy Configuration'],
    edit: ['Edit Policy Configuration'],
  },
  salesforce: {
    view: ['Show Salesforce Configuration', 'Edit Salesforce Configuration'],
    edit: ['Edit Salesforce Configuration'],
  },
}

export default Authorization
